/** */
import React from 'react';
import './spinner.css';

const Spinner = (props) => {
  return (
    <div className="gm-spinner-15">
      <div className="loadingio-spinner-dual-ring-jl2luvh8b9m">
        <div className="ldio-blvdbd1yqg">
          <div></div>
          <div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Spinner;
